<template>
  <div class="iframe-container">
    <AppNewHeader style="width: 100%" :placeholderText="'搜索知识资源'" />

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-progress
        type="circle"
        :percentage="progressPercent"
        :status="progressStatus"
      />
      <p class="loading-text">{{ loadingText }}</p>
    </div>

    <!-- 未授权提示 -->
    <div v-else-if="!hasPermission" class="auth-prompt">
      <div class="auth-content">
        <img class="error-image" :src="errer" alt="无权限提示" />
        <div class="error-text">
          <div class="error-title">您暂无访问权限</div>
          <div class="error-subtitle">请检查是否登录或联系管理员</div>
        </div>
      </div>
    </div>

    <!-- 授权通过显示内容 -->
    <iframe
      v-else
      ref="baiduIframe"
      :src="baiduUrl"
      frameborder="0"
      class="baidu-iframe"
      allowfullscreen
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { ElMessage, ElLoading } from "element-plus";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import { PostkCHECKOAUTH } from "@/api/index.js";
import { useRoute, useRouter } from "vue-router";
import errer from "@/assets/image/errer.png";
import { Cookie } from "@/utils/Cookie";

const route = useRoute();
const router = useRouter();

// 响应式数据
const searchQuery = ref("");
const baiduUrl = ref("http://192.168.1.227:8088/ceshi");
const baiduIframe = ref(null);
const loading = ref(true);
const hasPermission = ref(false);
const authError = ref("");
const showLoginButton = ref(false);
const loadingText = ref("正在验证权限...");
const progressPercent = ref(0);
const progressStatus = ref("");
const timer = ref(null);
const selectItem = ref([])

const handleIframeLoad = () => {
  timer.value = setInterval(() => {
    // const overlayDialog = document.getElementsByClassName('loginItem');
    // console.log(overlayDialog,'swdewidfhue')
    const iframe = baiduIframe.value
    console.log(iframe,'iframe');
    // if(iframe){
    //   const iframeDoc = iframe.contentWindow || iframe.contentDocument;
    //   console.log(iframeDoc,'iframeDoc');
    //   if (iframeDoc) {
    //     const targetElement = iframeDoc.document.getElementsByClassName('loginItem'); // 使用标准的 DOM 操作方法获取目标元素
    //     console.log(targetElement); // 打印目标元素到控制台
    //     timer.value = null;
    //   }
    // }
    // if(overlayDialog && overlayDialog.length >0){
    //   selectItem.value = overlayDialog;
    //   console.log(selectItem.value,'ssssssss')
    //   timer.value = null;
    // }
  }, 3000);
      // setTimeout(()=>{
      // const overlayDialog = document.getElementsByClassName('loginItem');
      // debugger
      // console.log(overlayDialog,'swdewidfhue')

      // },10000)
  // const iframe = baiduIframe.value
  // console.log(iframe,'iframe');
  // if(iframe){
    // const iframeDoc = iframe.contentDocument;
;
    
    // iframeDoc.getElementById('username').value = 'your_username';
    // iframeDoc.getElementById('password').value = 'your_password';
    
    // 触发登录按钮点击
    // iframeDoc.getElementById('login-btn').click();

   
};

// 校验流程
const checkAuth = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: "安全验证中...",
    background: "rgba(0, 0, 0, 0.7)",
  });

  try {
    // 1. 检查本地token是否存在
    const token = JSON.parse(Cookie.get('token')) || '';
    if (!token) {
      console.log("未检测到登录信息");
    }

    // 2. 检查token是否过期
    if (checkTokenExpiration(token)) {
      console.log("登录会话已过期");
    }

    // 3. 检查接口权限
    const id = route.query.id;
    baiduUrl.value = route.query.Url;

    if (!id) {
      console.log("缺少资源标识参数");
    }

    updateProgress(30, "正在验证资源权限...");
    const res = await PostkCHECKOAUTH({ knowledgeId: id });


    if (!res?.info) {
      console.log("接口返回数据异常");
    }

    if (res.status !== 200 && res.info === true) {
      console.log(res.info.message || "您没有访问该资源的权限");
    }

    // 所有检查通过
    updateProgress(100, "验证通过，加载资源...");
    hasPermission.value = true;
  } catch (error) {
    console.error("验证失败:", error);
    authError.value = error.message;
    showLoginButton.value = error.message.includes("登录");
    ElMessage.error(error.message);
  } finally {
    loading.value = false;
    loadingInstance.close();
    setTimeout(() => {
      progressPercent.value = 0;
    }, 500);
  }
};

// Token过期检查
const checkTokenExpiration = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp && Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
};

// 更新进度条
const updateProgress = (percent, text) => {
  progressPercent.value = percent;
  if (text) loadingText.value = text;
  progressStatus.value = percent < 70 ? "" : "success";
};

// // 跳转登录
// const redirectToLogin = () => {
//   router.push({
//     path: '/login',
//     query: { redirect: route.fullPath }
//   });
// };

// iframe加载完成回调
const onIframeLoad = () => {
  ElMessage.success("资源加载完成");
};

// 组件挂载时执行验证
onMounted(() => {
  checkAuth();
  handleIframeLoad()
});
</script>

<style scoped>
.iframe-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}

.loading-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
  gap: 20px;
}

.loading-text {
  color: #606266;
  font-size: 16px;
}

/* 修改后的授权提示样式 */
.auth-prompt {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
}

.auth-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
}

.error-image {
  width: 260px;
  height: 216px;
  object-fit: contain;
}

.error-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.error-title {
  /* width: 182px; */
  /* height: 48px; */
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-style: normal;
}

.error-subtitle {
  font-size: 14px;
  color: #999999;
}

.baidu-iframe {
  width: 100%;
  flex-grow: 1;
  border: none;
  background: white;
}

/* 响应式调整 */
/* @media (max-width: 768px) {
  .loading-text {
    font-size: 14px;
  }

  .error-image {
    width: 200px;
    height: auto;
  }

  .error-title {
    font-size: 16px;
  }

  .error-subtitle {
    width: 182px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: right;
    font-style: normal;
  }
} */
</style>
